import src from "IMAGE";
export default { src, width: 98, height: 16, blurWidth: 0, blurHeight: 0};
